module.exports = __webpack_public_path__ + "vg.a78384da85b31fbb6199.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/vg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/vg.svg
// module chunks = styles